import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
// import Slider from 'react-slick';
// import classNames from 'classnames';
import s from './InfocusList.scss';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

class InfocusList extends React.Component {
  // constructor(props) {
  //   super(props);
  // }
  componentDidMount() {
    //if (window) window.addEventListener('resize', this.onWindowResize);
  }

  getItemGA = itemText => {
    const { gaCategory, gaAction, sectionData } = this.props;
    const finalcategory =
      sectionData && sectionData.sectionName
        ? `${gaCategory}_${sectionData.sectionName}`
        : `${gaCategory}`;
    const gaWithCategoryAction =
      gaCategory && gaAction
        ? // ? `${gaCategory}|${gaAction}_${index}|${itemText}${wu && `_${wu}`}`
          `${finalcategory}|${gaAction}-MoreFromEtimes_NewsItem|${itemText}`
        : `MoreFromEtimes_NewsItem-Actions|Click-MoreFromEtimes_NewsItem/${itemText}`;
    return gaWithCategoryAction;
  };
  renderList(itemsList, ga4Category, ga4Type, cssSelectorClass, sectionData) {
    if (itemsList) {
      // console.log('sectionData', sectionData);
      return (
        <InViewObserver
          inViewCallback={() => {
            if (ga4Type) {
              analyticsWrapper('ga4', {
                event: 'user_shown',
                type: `${ga4Type}`,
                category: `${ga4Category || ''}`,
              });
            }
          }}
        >
          <div
            className={`${s.trending} ${cssSelectorClass} ${s.infocuswrapper}${
              this.props?.articletrendinglist ? `infocuswrapper` : ''
            }`}
            id={
              sectionData && sectionData.id === 'keywords' ? sectionData.id : ''
            }
          >
            <div className={s.moreStories}>
              <div className={s.left}>
                <h3
                  dangerouslySetInnerHTML={{
                    __html: `${sectionData && sectionData.name}`,
                  }}
                />
                <strong>{sectionData && sectionData.sectionName}</strong>
              </div>
              <div className={s.linksWrap}>
                {itemsList.map((item, index) => {
                  const heading =
                    item &&
                    item.hl &&
                    typeof item.hl === 'string' &&
                    item.hl.split('**:').length > 0
                      ? item.hl.split('**:')[0]
                      : item.hl;
                  return (
                    <Link
                      key={item.id}
                      to={item.wu}
                      className="keyword"
                      data-ga={`${this.getItemGA(heading, index + 1, item.wu)}`}
                      target={item.target === '_blank' ? item.target : ''}
                      ga4Data={
                        ga4Type && [
                          {
                            event: 'user_click',
                            type: `${ga4Type}`,
                            label: `${heading}`,
                            category: `${ga4Category || 'story_click'}`,
                            story_no: index + 1,
                            msid: item?.id,
                          },
                        ]
                      }
                    >
                      {heading}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </InViewObserver>
      );
    }
    return null;
  }
  render() {
    const { sectionData } = this.props;
    const { items, data, ga4Category, ga4Type } = sectionData;
    const itemsList = data && data.length ? data : items;

    const { cssSelector } = this.props;
    const cssSelectorClass = s[cssSelector];
    return this.renderList(
      itemsList,
      ga4Category,
      ga4Type,
      cssSelectorClass,
      sectionData,
    );
  }
}

InfocusList.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  cssSelector: PropTypes.string,
  gaCategory: PropTypes.string,
  gaAction: PropTypes.string,
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
};

InfocusList.defaultProps = {
  cssSelector: '',
  gaCategory: '',
  gaAction: '',
  ga4Category: '',
  ga4Type: '',
};
export default InfocusList;
